import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CustomerFeatureQueryKeys } from "./keys";
import { IUpdateCustomerFeatures } from "../../models/CustomerFeature/UpdateCustomerFeature";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";

export default function useCustomerFeaturesMutations(customerId: string) {
  const queryClient = useQueryClient();
  const { saveHandlers } = useDefaultCRUDHandlers("Customer Features");
  const { put } = useApiHelper();

  const update = useMutation({
    mutationFn: (updatedFeatures: IUpdateCustomerFeatures) =>
      put(`/customer/${customerId}/features`, updatedFeatures),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CustomerFeatureQueryKeys.all(customerId),
      });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  return {
    update,
  };
}
